export default __webpack_public_path__ + "static/media/cross.ff1f4aca.svg";